import React from 'react';
import Icon from '../../../components/AppIcon';

const ValidationPanel = ({ connection }) => {
  const validationRules = [
    {
      category: 'PNG Employment Act Compliance',
      rules: [
        { name: 'Minimum Wage Validation', status: 'passing', description: 'All employees meet K3.50/hour minimum' },
        { name: 'Overtime Rate Check', status: 'passing', description: '1.5x rate applied correctly' },
        { name: 'Sunday Rate Verification', status: 'passing', description: '2x rate for Sunday work' }
      ]
    },
    {
      category: 'Data Integrity',
      rules: [
        { name: 'Duplicate Detection', status: 'passing', description: 'No duplicate employee records found' },
        { name: 'Missing Field Alerts', status: 'warning', description: '3 records missing department' },
        { name: 'Data Type Validation', status: 'passing', description: 'All fields match expected types' }
      ]
    },
    {
      category: 'Statutory Deductions',
      rules: [
        { name: 'NASFUND Calculation', status: 'passing', description: '6% employee, 8.4% employer' },
        { name: 'SWT Withholding', status: 'passing', description: 'Tax brackets applied correctly' },
        { name: 'Leave Accrual Rates', status: 'passing', description: 'Annual and sick leave compliant' }
      ]
    }
  ];

  const getStatusIcon = (status) => {
    switch (status) {
      case 'passing':
        return <Icon name="CheckCircle" size={20} className="text-success" />;
      case 'warning':
        return <Icon name="AlertCircle" size={20} className="text-warning" />;
      case 'failing':
        return <Icon name="XCircle" size={20} className="text-error" />;
      default:
        return <Icon name="Circle" size={20} className="text-muted-foreground" />;
    }
  };

  const getStatusBadge = (status) => {
    const config = {
      passing: { label: 'Passing', color: 'bg-success/10 text-success' },
      warning: { label: 'Warning', color: 'bg-warning/10 text-warning' },
      failing: { label: 'Failing', color: 'bg-error/10 text-error' }
    };
    const badge = config?.[status] || config?.passing;
    return (
      <span className={`px-2 py-1 rounded text-xs font-medium ${badge?.color}`}>
        {badge?.label}
      </span>
    );
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-foreground">Validation & Compliance</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Real-time validation ensuring data integrity and PNG Employment Act compliance
        </p>
      </div>

      <div className="space-y-6">
        {validationRules?.map((category, index) => (
          <div key={index} className="bg-background border border-border rounded-lg p-5">
            <h3 className="text-lg font-semibold text-foreground mb-4">{category?.category}</h3>
            <div className="space-y-3">
              {category?.rules?.map((rule, ruleIndex) => (
                <div key={ruleIndex} className="flex items-center gap-4 p-4 bg-card border border-border rounded-lg">
                  <div className="flex-shrink-0">
                    {getStatusIcon(rule?.status)}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                      <h4 className="font-medium text-foreground">{rule?.name}</h4>
                      {getStatusBadge(rule?.status)}
                    </div>
                    <p className="text-sm text-muted-foreground">{rule?.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValidationPanel;
